export default __webpack_public_path__ + "static/media/bg-flow-4.0f6d6698.png";